// extracted by mini-css-extract-plugin
module.exports = {"videoResponsive":"YoutubeEmbed_videoResponsive__2Js80"};